/*export const REDIRECT_URLS = [
  ['/de/blog/interview/novye-tehnologii-kak-instrument-prodazh-v-evrope-i-rossii-v-chem-raznica/', '/de/'],
  ['/de/blog/news/akciya-promajskie-s-planoplan--15-dlya-vseh-polzovatelej/', '/de/blog/news/'],
  ['/de/blog/news/irina-sachek-dizajner-intererov/', '/de/blog/interview/interior-designer-irina-sachek/'],
  ['/de/blog/news/kak-poluchit-pro-na-2-nedeli-besplatno/', '/de/blog/news/'],
  ['/de/blog/news/promokod-na-40-dlya-novichkov-i-otklyuchenie-sveta-4-i-5-yanvarya/', '/de/blog/news/'],
  ['/de/blog/news/sertificate-gift/', '/de/blog/news/'],
  ['/de/blog/news/vozmozhny-problemy-s-renderami/', '/de/blog/news/'],
  ['/en/blog/interview/novye-tehnologii-kak-instrument-prodazh-v-evrope-i-rossii-v-chem-raznica/', '/en/'],
  ['/en/blog/news/akciya-promajskie-s-planoplan--15-dlya-vseh-polzovatelej/', '/en/blog/news/'],
  ['/en/blog/news/irina-sachek-dizajner-intererov/', '/en/blog/interview/interior-designer-irina-sachek/'],
  ['/en/blog/news/kak-poluchit-pro-na-2-nedeli-besplatno/', '/en/blog/news/'],
  ['/en/blog/news/promokod-na-40-dlya-novichkov-i-otklyuchenie-sveta-4-i-5-yanvarya/', '/en/blog/news/'],
  ['/en/blog/news/sertificate-gift/', '/en/blog/news/'],
  ['/en/blog/news/vozmozhny-problemy-s-renderami/', '/en/blog/news/'],
  ['/ru/blog/interview/novye-tehnologii-kak-instrument-prodazh-v-evrope-i-rossii-v-chem-raznica/', '/ru/'],
  ['/ru/blog/news/akciya-promajskie-s-planoplan--15-dlya-vseh-polzovatelej/', '/ru/blog/news/'],
  ['/ru/blog/news/irina-sachek-dizajner-intererov/', '/ru/blog/interview/interior-designer-irina-sachek/'],
  ['/ru/blog/news/kak-poluchit-pro-na-2-nedeli-besplatno/', '/ru/blog/news/'],
  ['/ru/blog/news/promokod-na-40-dlya-novichkov-i-otklyuchenie-sveta-4-i-5-yanvarya/', '/ru/blog/news/'],
  ['/ru/blog/news/sertificate-gift/', '/ru/blog/news/'],
  ['/ru/blog/news/vozmozhny-problemy-s-renderami/', '/ru/blog/news/'],
  ['/ru/demo/new/', '/ru/'],
  ['/ru/library/faq/errors/app-or-website-does-not-work/', '/ru/library/faq/errors/application-setup-error/'],
  [
    '/ru/blog/interview/foto-syna-optimus-prajm-i-hokkejnaya-shajba-chto-lezhit-na-stole-u-unity-razrabotchika/',
    '/ru/blog/interview/',
  ],
  ['/ru/blog/instructions/reshenie-problem/', '/ru/blog/'],
  ['/ru/blog/instructions/podelitsya-renderomvr-panoramoj/', '/ru/blog/'],
  ['/ru/blog/articles/vr-dlya-zastrojshikov-resheniya-kelnika-dlya-navis/', 'https://b2b.planoplan.com/'],
  [
    '/en/blog/articles/pokupatel-nedvizhimosti-pomolodel-i-stal-bolshe-cenit-tehnologichnost/',
    'https://b2b.planoplan.com/',
  ],
  ['/ru/blog/articles/obzor-trend-na-virtualizaciyu/', 'https://b2b.planoplan.com/'],
  ['/ru/blog/articles/expo-real-2016-vr-ne-prosto-igrushka/', 'https://b2b.planoplan.com/'],
  ['/ru/blog/articles/intervyu-vr-daet-bolshe-vozmozhnostej-dlya-dialoga/', 'https://b2b.planoplan.com/'],
  ['/ru/blog/articles/million-kvadratnyh-metrov-kvartir-v-novostrojkah/', 'https://b2b.planoplan.com/'],
  ['/ru/blog/articles/top-likvidnyh-planirovok-ili-kak-vybrat-kvartiru-dlya-sebya/', 'https://b2b.planoplan.com/'],
  ['/ru/blog/articles/ultrafiolet-oficialnyj-cvet-2018/', '/ru/blog/'],
  [
    '/ru/blog/articles/oleg-kelnik-rasskazal-o-slozhnostyah-ekspansii-na-zarubezhnyj-rynok/',
    'https://b2b.planoplan.com/',
  ],
  ['/ru/blog/articles/pokupatel-hochet-uvidet/', '/ru/blog/'],
  ['/ru/blog/articles/virtualnaya-realnost-obnazhila-problemy-marketinga/', '/ru/blog/'],
  ['/ru/blog/articles/sluchajnoe-otkrytie-ot-borby-s-rabochej-rutinoj-k-novomu-biznesu/', '/ru/blog/'],
  ['/ru/blog/articles/kosyak-neizbezhen-kak-ispravit-nedochety-kotorye-obnaruzhili-posle-remonta/', '/ru/blog/'],
  [
    '/ru/blog/articles/kak-samomu-sdelat-dizajn-kvartiry-onlajn-ot-risovaniya-plana-do-rasstanovki-mebeli/',
    '/ru/blog/',
  ],
  ['/ru/blog/news/prilozhenie-planoplan-go-teper-podderzhivaet-funkciyu-vybora-otdelki/', '/ru/blog/'],
  ['/ru/blog/news/planoplan-na-kanale-vesti24/', '/ru/blog/'],
  ['/ru/blog/news/klienty-lerua-merlen-oprobovali-planoplan-na-praktike/', '/ru/blog/'],
  ['/ru/blog/news/kak-ne-brat-kota-v-meshke-lenovo-rasskazal-o-planoplan/', '/ru/blog/'],
  ['/ru/blog/news/105/', '/ru/blog/'],
  ['/ru/blog/news/104/', '/ru/blog/'],
  ['/ru/blog/news/novogodnyaya-rasprodazha-28.1207.01', '/ru/blog/'],
  ['/ru/blog/news/vesennyaya-rasprodazha-06.0309.03', '/ru/blog/'],
  ['/ru/blog/news/bezlimitnaya-zagruzka-modelej-na-tarife-proplus/', '/ru/blog/'],
  ['/ru/blog/news/novyj-sajt/', '/ru/blog/'],
  ['/ru/blog/news/09.1011.10-osennyaya-rasprodazha', '/ru/blog/'],
  ['/ru/blog/news/tehnicheskie-raboty-na-servere/', '/ru/blog/'],
  ['/ru/blog/news/27.1129.11-chernaya-pyatnica-30', '/ru/blog/'],
  ['/ru/blog/news/prazdnik-s-planoplan/', '/ru/blog/'],
  ['/ru/blog/news/tehnicheskie-nepoladki-31.03.21', '/ru/blog/'],
  ['/ru/blog/news/tehnicheskie-nepoladki/', '/ru/blog/'],
  ['/ru/blog/news/tehnicheskie-raboty-na-servere/', '/ru/blog/'],
  ['/ru/blog/news/vremya-ozhidaniya-rendera-uvelicheno/', '/ru/blog/'],
  ['/ru/blog/news/vremya-ozhidaniya-rendera-uvelicheno/', '/ru/blog/'],
  ['/ru/blog/news/2628.11-33-na-vse', '/ru/blog/'],
  ['/ru/blog/news/chernaya-pyatnica/', '/ru/blog/'],
  ['/ru/blog/news/24-26-noyabrya-chernaya-pyatnica/', '/ru/blog/'],
  ['/ru/blog/news/pro-so-skidkoj-31-pri-pokupke-na-god/', '/ru/blog/'],
  ['/ru/blog/news/-akciya-50-na-rendery/', '/ru/blog/'],
];*/

export const REDIRECT_URLS = [
  [
    '/blog/articles/vozmozhnosti-tarifa-planoplan-pro/',
    '/blog/articles/planoplan-dlya-professionalov-v-oblasti-dizajna-intererov/',
  ],
  ['/blog/interview/novye-tehnologii-kak-instrument-prodazh-v-evrope-i-rossii-v-chem-raznica/', '/'],
  ['/blog/news/akciya-promajskie-s-planoplan--15-dlya-vseh-polzovatelej/', '/blog/news/'],
  ['/blog/news/irina-sachek-dizajner-intererov/', '/blog/interview/interior-designer-irina-sachek/'],
  ['/blog/news/kak-poluchit-pro-na-2-nedeli-besplatno/', '/blog/news/'],
  ['/blog/news/promokod-na-40-dlya-novichkov-i-otklyuchenie-sveta-4-i-5-yanvarya/', '/blog/news/'],
  ['/blog/news/sertificate-gift/', '/blog/news/'],
  ['/blog/news/vozmozhny-problemy-s-renderami/', '/blog/news/'],
  ['/demo/new/', '/'],
  ['/library/faq/errors/app-or-website-does-not-work/', '/library/faq/errors/application-setup-error/'],
  [
    '/blog/interview/foto-syna-optimus-prajm-i-hokkejnaya-shajba-chto-lezhit-na-stole-u-unity-razrabotchika/',
    '/blog/interview/',
  ],
  [
    '/blog/interview/photo-of-the-son-optimus-prime-and-hockey-puck-what-does-unity-developer-have-on-his-desk/',
    '/blog/interview/',
  ],
  ['/blog/instructions/reshenie-problem/', '/blog/'],
  ['/blog/instructions/problem-solving/', '/blog/'],
  ['/blog/instructions/podelitsya-renderomvr-panoramoj/', '/blog/'],
  ['/blog/instructions/share-renderingvr-panorama/', '/blog/'],
  ['/blog/articles/vr-dlya-zastrojshikov-resheniya-kelnika-dlya-navis/', 'https://flat.planoplan.com/'],
  ['/blog/articles/vr-for-developers-kelniks-solutions-for-navis-development-group/', '/blog/articles'],
  [
    '/blog/articles/pokupatel-nedvizhimosti-pomolodel-i-stal-bolshe-cenit-tehnologichnost/',
    'https://flat.planoplan.com/',
  ],
  ['/blog/articles/obzor-trend-na-virtualizaciyu/', 'https://flat.planoplan.com/'],

  ['/blog/articles/expo-real-2016-vr-ne-prosto-igrushka/', 'https://flat.planoplan.com/'],
  ['/blog/articles/expo-real-2016-vr-is-not-just-a-toy/', '/blog/articles'],
  ['/blog/articles/intervyu-vr-daet-bolshe-vozmozhnostej-dlya-dialoga/', 'https://flat.planoplan.com/'],
  ['/blog/articles/million-kvadratnyh-metrov-kvartir-v-novostrojkah/', 'https://flat.planoplan.com/'],
  ['/blog/articles/top-likvidnyh-planirovok-ili-kak-vybrat-kvartiru-dlya-sebya/', 'https://flat.planoplan.com/'],
  ['/blog/articles/ultrafiolet-oficialnyj-cvet-2018/', '/blog/'],
  [
    '/blog/articles/oleg-kelnik-rasskazal-o-slozhnostyah-ekspansii-na-zarubezhnyj-rynok/',
    'https://flat.planoplan.com/',
  ],
  ['/blog/articles/pokupatel-hochet-uvidet/', '/blog/'],
  ['/blog/articles/virtualnaya-realnost-obnazhila-problemy-marketinga/', '/blog/'],
  ['/blog/articles/sluchajnoe-otkrytie-ot-borby-s-rabochej-rutinoj-k-novomu-biznesu/', '/blog/'],
  ['/blog/articles/kosyak-neizbezhen-kak-ispravit-nedochety-kotorye-obnaruzhili-posle-remonta/', '/blog/'],
  ['/blog/articles/kak-samomu-sdelat-dizajn-kvartiry-onlajn-ot-risovaniya-plana-do-rasstanovki-mebeli/', '/blog/'],
  ['/blog/news/prilozhenie-planoplan-go-teper-podderzhivaet-funkciyu-vybora-otdelki/', '/blog/'],
  ['/blog/news/planoplan-na-kanale-vesti24/', '/blog/'],
  ['/blog/news/klienty-lerua-merlen-oprobovali-planoplan-na-praktike/', '/blog/'],
  ['/blog/news/kak-ne-brat-kota-v-meshke-lenovo-rasskazal-o-planoplan/', '/blog/'],
  ['/blog/news/105/', '/blog/'],
  ['/blog/news/104/', '/blog/'],
  ['/blog/news/novogodnyaya-rasprodazha-28.1207.01/', '/blog/'],
  ['/blog/news/new-years-sale-28.1207.01/', '/blog/'],
  ['/blog/news/vesennyaya-rasprodazha-06.0309.03/', '/blog/'],
  ['/blog/news/spring-sale-06.0309.03/', '/blog/'],
  ['/blog/news/bezlimitnaya-zagruzka-modelej-na-tarife-proplus/', '/blog/'],
  ['/blog/news/unlimited-model-uploads-on-proplus-tariff/', '/blog/'],
  ['/blog/news/novyj-sajt/', '/blog/'],
  ['/blog/news/new-site/', '/blog/'],
  ['/blog/news/159/', '/blog/'],
  ['/blog/news/09.1011.10-osennyaya-rasprodazha/', '/blog/'],
  ['/blog/news/09.1011.10-autumn-sale/', '/blog/'],
  ['/blog/news/tehnicheskie-raboty-na-servere/', '/blog/'],
  ['/blog/news/server-technical-works/', '/blog/'],
  ['/blog/news/27.1129.11-chernaya-pyatnica-30/', '/blog/'],
  ['/blog/news/27.11-29.11-black-friday--30', '/blog/'],
  ['/blog/news/prazdnik-s-planoplan/', '/blog/'],
  ['/blog/news/celebrate-with-planoplan/', '/blog/'],
  ['/blog/news/tehnicheskie-nepoladki-31.03.21/', '/blog/'],
  ['/blog/news/technical-problems-31.03.21/', '/blog/'],
  ['/blog/news/technical-problems/', '/blog/'],
  ['/blog/news/tehnicheskie-nepoladki/', '/blog/'],
  ['/blog/news/tehnicheskie-raboty-na-servere/', '/blog/'],
  ['/blog/news/server-maintenance/', '/blog/'],
  ['/blog/news/vremya-ozhidaniya-rendera-uvelicheno/', '/blog/'],
  ['blog/news/render-waiting-time-increased/', '/blog/'],
  ['/blog/news/2628.11-33-na-vse/', '/blog/'],
  ['/blog/news/26-28.11-33offeverything/', '/blog/'],
  ['/blog/news/chernaya-pyatnica/', '/blog/'],
  ['/blog/news/24-26-noyabrya-chernaya-pyatnica/', '/blog/'],
  ['/blog/news/24-26-nov-black-friday/', '/blog/'],
  ['/blog/news/pro-so-skidkoj-31-pri-pokupke-na-god/', '/blog/'],
  ['/blog/news/-31-off-for-pro-annual-subscription/', '/blog/'],
  ['/blog/news/-akciya-50-na-rendery/', '/blog/'],
  ['/blog/news/-50-off-for-rendering-package/', '/blog/'],
  ['/blog/news/chernaya-pyatnica-vplanoplane/', '/blog/'],
  ['/blog/news/black-friday-atplanoplan/', '/blog/'],
  ['/education/courses/', '/help-center/learning-modules/'],
  ['/education/', '/help-center/'],
  ['/education/videos/', '/help-center/video-tutorials/'],
  ['/education/videos/basic/', '/help-center/video-tutorials/'],
  ['/education/videos/pro/', '/help-center/video-tutorials/'],
  ['/education/videos/drawings/', '/help-center/video-tutorials/'],
  ['/education/videos/visual/', '/help-center/video-tutorials/visualization/'],
  ['/education/videos/team/', '/help-center/video-tutorials/'],
  ['/education/buttons/', '/help-center/keyboard-shortcuts/'],
  ['/library/', '/help-center/'],
  ['/library/faq/', '/help-center/troubleshooting/'],
  [
    '/library/faq/enter-sign-in/cancel-auto-renew/',
    '/help-center/documentation/installation-and-customization/user-dashboard/',
  ],
  [
    '/library/faq/enter-sign-in/confirmation-code/',
    '/help-center/troubleshooting/other-issues/confirmation-code-not-received/',
  ],
  [
    '/library/faq/enter-sign-in/delete-account/',
    '/help-center/documentation/installation-and-customization/user-dashboard/',
  ],
  ['/library/faq/enter-sign-in/end-trial/', '/help-center/troubleshooting/'],
  ['/library/faq/enter-sign-in/restore-password/', '/help-center/troubleshooting/'],
  ['/library/faq/enter-sign-in/tariff-end/', '/help-center/troubleshooting/'],
  [
    '/library/faq/enter-sign-in/unsubscribe/',
    '/help-center/documentation/installation-and-customization/user-dashboard/',
  ],
  [
    '/library/faq/enter-sign-in/user-id/',
    '/help-center/troubleshooting/problems-with-the-program/how-to-find-your-user-id-in-planoplan/',
  ],
  [
    '/library/faq/enter-sign-in/wrong-email/',
    '/help-center/troubleshooting/other-issues/incorrect-email-address-during-registration/',
  ],
  [
    '/library/faq/errors/application-setup-error/',
    '/help-center/troubleshooting/problems-with-the-program/cant-install-the-app.-error-2502-or-2503',
  ],
  [
    '/library/faq/errors/no-floor/',
    '/help-center/troubleshooting/problems-with-the-program/i-cant-see-the-floor-or-ceiling-in-the-room/',
  ],
  [
    '/library/faq/errors/no-roof/',
    '/help-center/troubleshooting/problems-with-the-program/how-to-reinstall-planoplan-app/',
  ],
  ['/library/faq/project/attic-floor/', '/help-center/troubleshooting/'],
  ['/library/faq/project/basement/', '/help-center/troubleshooting/'],
  ['/library/faq/project/ceiling-height/', '/help-center/troubleshooting/'],
  ['/library/faq/project/grid-shape/', '/help-center/troubleshooting/'],
  [
    '/library/faq/project/log-in-from-another-computer/',
    '/help-center/troubleshooting/other-issues/how-can-i-or-another-user-access-my-project-from-another-computer/',
  ],
  ['/library/faq/project/move-project/', '/help-center/documentation/project-creation/layouts/'],
  [
    '/library/faq/project/no-open-3d/',
    '/help-center/troubleshooting/problems-with-the-program/project-wont-open-in-3d/',
  ],
  ['/library/faq/project/object-removal/', '/help-center/video-tutorials/catalog/list-of-objects/'],
  [
    '/library/faq/project/project-id/',
    '/help-center/troubleshooting/problems-with-the-program/how-to-find-a-project-id-in-planoplan/',
  ],
  [
    '/library/faq/project/project-recovery/',
    '/help-center/troubleshooting/problems-with-the-program/accidentally-deleted-a-project-can-it-be-restored/',
  ],
  ['/library/faq/project/share-project/', '/help-center/troubleshooting/'],
  ['/library/faq/project/surface-zoning/', '/help-center/documentation/2d-work/wall-with-0-height/'],
  ['/library/faq/project/tile-layout/', '/help-center/troubleshooting/'],
  ['/library/faq/project/wall-concealment/', '/help-center/troubleshooting/'],
  ['/library/faq/renders/renders-without-logo/', '/help-center/troubleshooting/'],
  ['/library/faq/renders/vr-tour/', '/help-center/documentation/visualization/creating-virtual-tours/'],
  ['/library/faq/tools/led-backlight/', '/help-center/troubleshooting/'],
  ['/library/faq/tools/model-upload/', '/help-center/video-tutorials/catalog/uploading-your-own-models/'],
  ['/library/faq/tools/skirting-board/', '/help-center/troubleshooting/'],
  ['/library/faq/tools/track-lighting/', '/help-center/troubleshooting/'],
  ['/library/getstarted/', '/help-center/learning-modules/for-beginners/'],
  [
    '/library/getstarted/application-settings/checkboxes/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/interface-language/',
    '/help-center/documentation/installation-and-customization/user-dashboard/',
  ],
  [
    '/library/getstarted/application-settings/interface-scale/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/performance-tuning/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/performance-tuning/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/settings/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/units-of-measure/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/application-settings/use-local-cache/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  [
    '/library/getstarted/getting-started/helper-new-project/',
    '/help-center/documentation/project-creation/sozdanie-novogo-proekta/',
  ],
  [
    '/library/getstarted/getting-started/helper-projects-panel/',
    '/help-center/documentation/project-creation/layouts/',
  ],
  ['/library/getstarted/getting-started/knowledge-library/', '/help-center/documentation/'],
  [
    '/library/getstarted/getting-started/loading-and-installation/',
    '/help-center/documentation/installation-and-customization/download-and-installation/',
  ],
  [
    '/library/getstarted/getting-started/main-functions/',
    '/help-center/documentation/installation-and-customization/features-and-capabilities/',
  ],
  [
    '/library/getstarted/getting-started/my-account/',
    '/help-center/documentation/installation-and-customization/user-dashboard/',
  ],
  [
    '/library/getstarted/getting-started/registration-and-authorization/',
    '/help-center/documentation/installation-and-customization/registration-and-login/',
  ],
  ['/library/tools/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-adddimensionline/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-addfigure/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-addlabel/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-addpolygonalline/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-addtable/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-image/', '/help-center/documentation/'],
  ['/library/tools/designations/helper-showmoredrawings/', '/help-center/documentation/'],
  ['/library/tools/designations/menu-designations/', '/help-center/documentation/'],
  [
    '/library/tools/make-renders/helper-createscreenshotbutton/',
    '/help-center/documentation/visualization/creating-renders/',
  ],
  [
    '/library/tools/make-renders/helper-createvrbutton/',
    '/help-center/documentation/visualization/creating-360-panoramas/',
  ],
  ['/library/tools/make-renders/move-mode/', '/help-center/documentation/project-creation/operating-modes/'],
  ['/library/tools/make-renders/setting-camera/', '/help-center/documentation/visualization/creating-renders/'],
  ['/library/tools/make-renders/setting-render/', 'https://planoplan.com/ru/help-center/documentation/visualization/'],
  [
    '/library/tools/right-vertical-bar/helper-3dtoggle/',
    '/help-center/documentation/project-creation/operating-modes/',
  ],
  ['/library/tools/right-vertical-bar/helper-center/', '/help-center/documentation/'],
  ['/library/tools/right-vertical-bar/helper-helpcenter/', '/help-center/documentation/'],
  [
    '/library/tools/right-vertical-bar/helper-plantoggle/',
    '/help-center/documentation/project-creation/operating-modes/',
  ],
  [
    '/library/tools/right-vertical-bar/helper-walktoggle/',
    '/help-center/documentation/project-creation/operating-modes/',
  ],
  ['/library/tools/right-vertical-bar/helper-zoom/', '/help-center/documentation/project-creation/operating-modes/'],
  ['/library/tools/test/helper-exportplan/', '/help-center/documentation/2d-work/exporting-a-plan/'],
  ['/library/tools/test/helper-projectsettings-1/', '/help-center/documentation/'],
  ['/library/tools/test/helper-redo/', '/help-center/documentation/'],
  ['/library/tools/test/helper-renameproject/', '/help-center/documentation/'],
  ['/library/tools/test/helper-rulertoggle/', '/help-center/documentation/2d-work/ruler/'],
  ['/library/tools/test/helper-showfloorlist/', '/help-center/documentation/2d-work/floors/'],
  [
    '/library/tools/test/helper-snaps/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  ['/library/tools/test/helper-sun/', '/help-center/documentation/visualization/sunlight/'],
  ['/library/tools/test/helper-undo/', '/help-center/documentation/'],
  ['/library/tools/test/project-save-indicator/', '/help-center/documentation/'],
  ['/library/tools/test/tool-bar/', '/help-center/documentation/'],
  ['/library/tools/toolkit/community/', '/help-center/documentation/catalog/community-sharing-models-and-textures/'],
  ['/library/tools/toolkit/free-fransform/', '/help-center/documentation/catalog/free-transform/'],
  ['/library/tools/toolkit/load-models/', '/help-center/video-tutorials/catalog/uploading-your-own-models/'],
  ['/library/tools/toolkit/specification/', '/help-center/documentation/2d-work/specification/'],
  ['/library/tools/toolkit/wall-elevation/', '/help-center/documentation/3d-work/wall-elevations/'],
  ['/library/tools/view/helper-panorama/', '/help-center/documentation/visualization/panorama/'],
  ['/library/tools/view/menu-view/', '/help-center/documentation/'],
  ['/library/tools/wall-construction/helper-constructbalcony/', '/help-center/documentation/2d-work/building-walls/'],
  ['/library/tools/wall-construction/helper-constructbycenter/', '/help-center/documentation/2d-work/building-walls/'],
  ['/library/tools/wall-construction/helper-constructbyedge/', '/help-center/documentation/2d-work/building-walls/'],
  ['/library/tools/wall-construction/helper-constructbyroom/', '/help-center/documentation/2d-work/building-walls/'],
  ['/library/tools/wall-construction/helper-constructdrywall/', '/help-center/documentation/2d-work/building-walls/'],
  [
    '/library/tools/wall-construction/helper-constructlock/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  ['/library/tools/wall-construction/menu-construct/', '/help-center/documentation/2d-work/building-walls/'],
  ['/library/tools/gallary/helper-showgallery/', '/help-center/documentation/visualization/project-gallery/'],
  [
    '/library/tools/gallary/helper-showdesignproject/',
    '/help-center/documentation/documentation-and-demonstration/design-project/',
  ],
  [
    '/library/tools/gallary/helper-create-panoramas-tour/',
    '/help-center/documentation/visualization/creating-virtual-tours/',
  ],
  [
    '/library/faq/errors/reinstall/',
    '/help-center/troubleshooting/problems-with-the-program/how-to-reinstall-planoplan-app/',
  ],
  ['/library/tools/designations/helper-addcallout/', '/help-center/documentation/'],
  [
    '/library/tools/view/helper-showgrid/',
    '/help-center/documentation/installation-and-customization/settings-in-planoplan/',
  ],
  ['/library/tools/view/helper-showsubstratemenu/', '/help-center/documentation/2d-work/uploading-a-substrate/'],
  ['/library/tools/wall-construction/helper-constructbeam/', '/help-center/documentation/2d-work/building-walls/'],
  ['/blog/articles/interview-with-pavel-lapitsky/', '/blog/'],
  ['/blog/articles/intervyu-s-pavlom-lapickim/', '/blog/'],
  [
    '/blog/articles/planoplan-dlya-professionalov-v-oblasti-dizajna-intererov/',
    '/blog/articles/tarif-ekspert-v-planoplane-maksimum-vozmozhnostej-dlya-dizajnera-interera/',
  ],
  [
    '/blog/articles/planoplan-for-professional-interior-designers/',
    '/blog/articles/the-expert-plan-in-planoplan-maximum-capabilities-for-the-professional-interior-designer/',
  ],
  ['/start/', '/download/'],
  ['/manufacturers/', '/blog/articles/planoplan-dlya-yuridicheskih-lic/'],
];
